import React, { useState } from "react";
import { useShop } from "../context/ShopContext";
import "./Checkout.css";

import {
  FaUser,
  FaPhone,
  FaHome,
  FaMapMarkerAlt,
  FaEye,
  FaShoppingCart,
  FaPalette,
  FaRuler,
  FaBox,
  FaDollarSign,
  FaPaperPlane,
  FaTimes,
  FaChild
} from "react-icons/fa";


import {
  collection,
  addDoc
} from "firebase/firestore";

import { db } from "../firebase";



export default function Checkout(){


  const { cart } = useShop();


  const [name,setName] = useState("");
  const [phone,setPhone] = useState("");
  const [address,setAddress] = useState("");
  const [location,setLocation] = useState("");

  const [showPreview,setShowPreview] = useState(false);



  const total = cart.reduce(
    (sum,item)=>
      sum + Number(item.price) * item.quantity,
    0
  );





  const getLocation = ()=>{


    if(!navigator.geolocation){

      alert("Location not supported");
      return;

    }



    navigator.geolocation.getCurrentPosition(

      (position)=>{


        const lat = position.coords.latitude;
        const lng = position.coords.longitude;



        const mapLink =
        `https://www.google.com/maps?q=${lat},${lng}`;


        setLocation(mapLink);


      },


      ()=>{

        alert("Please allow location");

      }

    );


  };







  const handleOrder = async()=>{


    if(cart.length === 0){

      alert("Your cart is empty");
      return;

    }



    try{


      const orderData = {


        customer:{


          name:name,

          phone:phone,

          address:address,

          location:location


        },



        products: cart.map(item=>(


          {


            id:item.id,


            name:item.name,


            image:
            item.images?.[0] || "",


            color:
            item.color || "-",


            size:
            item.size || "-",


            quantity:item.quantity,


            price:item.price


          }


        )),



        total:total,


        createdAt:new Date()



      };





      const orderRef = await addDoc(

        collection(db,"orders"),

        orderData

      );




      const orderId = orderRef.id;




      const whatsapp = "96179427021";




      const message = `

✨ CUTIES NEW ORDER ✨


👤 CUSTOMER

Name:
${name || "-"}


Phone:
${phone || "-"}



📦 DELIVERY

Address:
${address || "-"}



🛍 PRODUCTS

${cart.map(item=>`

🧸 ${item.name}

🎨 Color:
${item.color || "-"}

📏 Size:
${item.size || "-"}

📦 Qty:
${item.quantity}

💰 Price:
${item.price}$


`).join(
"────────────"
)}



📸 VIEW ORDER WITH IMAGES:

https://kids-shop-26485.web.app/order/${orderId}



💵 TOTAL:

${total}$



🤍 Thank you for shopping with CUTIES

`;





      const url =

      `https://api.whatsapp.com/send?phone=${whatsapp}&text=${encodeURIComponent(message)}`;





      window.location.href = url;



    }

    catch(error){


      console.log(error);

      alert("Order failed");


    }



  };






return(


<div className="checkout-page">


<div className="checkout-container">





{/* FORM */}

<div className="checkout-form">


<h1>

Checkout <FaShoppingCart/>

</h1>





<div className="input-icon">

<FaUser/>

<input

placeholder="Your Name"

value={name}

onChange={(e)=>setName(e.target.value)}

/>

</div>





<div className="input-icon">

<FaPhone/>

<input

placeholder="Phone Number"

value={phone}

onChange={(e)=>setPhone(e.target.value)}

/>

</div>





<div className="input-icon">

<FaHome/>

<input

placeholder="Address"

value={address}

onChange={(e)=>setAddress(e.target.value)}

/>

</div>





<button

type="button"

onClick={getLocation}

>

<FaMapMarkerAlt/>

Get My Location

</button>




{
location &&

<p>

Location Added ✔

</p>

}





<button

type="button"

onClick={()=>setShowPreview(true)}

>

<FaEye/>

Preview Order

</button>



</div>








{/* PREVIEW */}


{

showPreview &&


<div className="order-preview">


<h2>

<FaEye/>

Order Preview

</h2>




<p>

<FaUser/>

{name || "-"}

</p>



<p>

<FaPhone/>

{phone || "-"}

</p>



<p>

<FaHome/>

{address || "-"}

</p>





<hr/>





{

cart.map(item=>(


<div

className="preview-item"

key={
item.id + item.color + item.size
}

>



<img

src={
item.images?.[0] || "/no-image.png"
}

alt={item.name}

/>




<div>


<h3>

<FaChild/>

{item.name}

</h3>




<p>

<FaPalette/>

{item.color || "-"}

</p>




<p>

<FaRuler/>

{item.size || "-"}

</p>



<p>

<FaBox/>

Qty:
{item.quantity}

</p>




<p>

<FaDollarSign/>

{item.price}$

</p>



</div>


</div>



))


}






<h3>

Total:

{total}$

</h3>






<div className="preview-actions">


<button

onClick={handleOrder}

>

<FaPaperPlane/>

Send Order

</button>





<button

onClick={()=>setShowPreview(false)}

>

<FaTimes/>

Cancel

</button>



</div>



</div>


}









{/* CART SUMMARY */}



<div className="checkout-summary">


<h2>

<FaShoppingCart/>

Your Cart

</h2>





{

cart.map(item=>(


<div

className="summary-card"

key={
item.id + item.color + item.size
}

>


<img

src={
item.images?.[0] || "/no-image.png"
}

alt={item.name}

/>





<div>


<h3>

{item.name}

</h3>



<p>

<FaPalette/>

{item.color || "-"}

</p>



<p>

<FaRuler/>

{item.size || "-"}

</p>




<p>

<FaBox/>

Qty:
{item.quantity}

</p>




<p className="price">

<FaDollarSign/>

{item.price}$

</p>



</div>



</div>



))


}





<h3>

Total:

{total}$

</h3>



</div>





</div>


</div>


);


}